import { render, staticRenderFns } from "./ManageBoardForm.vue?vue&type=template&id=06b6ad72&"
import script from "./ManageBoardForm.vue?vue&type=script&lang=js&"
export * from "./ManageBoardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports